import { j as t } from "./jsx-runtime.DGlMoOmv.js";
import * as E from "react";
import l from "react";
import { u as O, c as Z, a as ee } from "./index.stoqs9MZ.js";
import { c as oe } from "./index.BW3XI7yS.js";
import { u as te } from "./index.B4ZV02se.js";
import { P as V } from "./index.DMLWxr4u.js";
import { c as H, a as re, R as ae, T as ne } from "./index.DmdlVKe8.js";
import { u as ce } from "./index.BUG7NYeV.js";
import { u as ie } from "./index.BhJrV2wu.js";
import { F as se } from "./ChevronDown20.NQYj4T82.js";
import { c as v } from "./index.CxSWpsOB.js";
var d = "Accordion", le = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [S, de, pe] = oe(d), [C, Ve] = Z(d, [
  pe,
  H
]), k = H(), M = l.forwardRef(
  (o, n) => {
    const { type: e, ...r } = o, c = r, a = r;
    return /* @__PURE__ */ t.jsx(S.Provider, { scope: o.__scopeAccordion, children: e === "multiple" ? /* @__PURE__ */ t.jsx(we, { ...a, ref: n }) : /* @__PURE__ */ t.jsx(ue, { ...c, ref: n }) });
  }
);
M.displayName = d;
var [K, me] = C(d), [$, fe] = C(
  d,
  { collapsible: !1 }
), ue = l.forwardRef(
  (o, n) => {
    const {
      value: e,
      defaultValue: r,
      onValueChange: c = () => {
      },
      collapsible: a = !1,
      ...s
    } = o, [i, p] = O({
      prop: e,
      defaultProp: r ?? "",
      onChange: c,
      caller: d
    });
    return /* @__PURE__ */ t.jsx(
      K,
      {
        scope: o.__scopeAccordion,
        value: l.useMemo(() => i ? [i] : [], [i]),
        onItemOpen: p,
        onItemClose: l.useCallback(() => a && p(""), [a, p]),
        children: /* @__PURE__ */ t.jsx($, { scope: o.__scopeAccordion, collapsible: a, children: /* @__PURE__ */ t.jsx(L, { ...s, ref: n }) })
      }
    );
  }
), we = l.forwardRef((o, n) => {
  const {
    value: e,
    defaultValue: r,
    onValueChange: c = () => {
    },
    ...a
  } = o, [s, i] = O({
    prop: e,
    defaultProp: r ?? [],
    onChange: c,
    caller: d
  }), p = l.useCallback(
    (w) => i((f = []) => [...f, w]),
    [i]
  ), u = l.useCallback(
    (w) => i((f = []) => f.filter((h) => h !== w)),
    [i]
  );
  return /* @__PURE__ */ t.jsx(
    K,
    {
      scope: o.__scopeAccordion,
      value: s,
      onItemOpen: p,
      onItemClose: u,
      children: /* @__PURE__ */ t.jsx($, { scope: o.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ t.jsx(L, { ...a, ref: n }) })
    }
  );
}), [ve, b] = C(d), L = l.forwardRef(
  (o, n) => {
    const { __scopeAccordion: e, disabled: r, dir: c, orientation: a = "vertical", ...s } = o, i = l.useRef(null), p = te(i, n), u = de(e), f = ie(c) === "ltr", h = ee(o.onKeyDown, (x) => {
      if (!le.includes(x.key)) return;
      const W = x.target, I = u().filter((y) => !y.ref.current?.disabled), A = I.findIndex((y) => y.ref.current === W), T = I.length;
      if (A === -1) return;
      x.preventDefault();
      let m = A;
      const j = 0, R = T - 1, _ = () => {
        m = A + 1, m > R && (m = j);
      }, N = () => {
        m = A - 1, m < j && (m = R);
      };
      switch (x.key) {
        case "Home":
          m = j;
          break;
        case "End":
          m = R;
          break;
        case "ArrowRight":
          a === "horizontal" && (f ? _() : N());
          break;
        case "ArrowDown":
          a === "vertical" && _();
          break;
        case "ArrowLeft":
          a === "horizontal" && (f ? N() : _());
          break;
        case "ArrowUp":
          a === "vertical" && N();
          break;
      }
      const X = m % T;
      I[X].ref.current?.focus();
    });
    return /* @__PURE__ */ t.jsx(
      ve,
      {
        scope: e,
        disabled: r,
        direction: c,
        orientation: a,
        children: /* @__PURE__ */ t.jsx(S.Slot, { scope: e, children: /* @__PURE__ */ t.jsx(
          V.div,
          {
            ...s,
            "data-orientation": a,
            ref: p,
            onKeyDown: r ? void 0 : h
          }
        ) })
      }
    );
  }
), g = "AccordionItem", [xe, D] = C(g), z = l.forwardRef(
  (o, n) => {
    const { __scopeAccordion: e, value: r, ...c } = o, a = b(g, e), s = me(g, e), i = k(e), p = ce(), u = r && s.value.includes(r) || !1, w = a.disabled || o.disabled;
    return /* @__PURE__ */ t.jsx(
      xe,
      {
        scope: e,
        open: u,
        disabled: w,
        triggerId: p,
        children: /* @__PURE__ */ t.jsx(
          ae,
          {
            "data-orientation": a.orientation,
            "data-state": B(u),
            ...i,
            ...c,
            ref: n,
            disabled: w,
            open: u,
            onOpenChange: (f) => {
              f ? s.onItemOpen(r) : s.onItemClose(r);
            }
          }
        )
      }
    );
  }
);
z.displayName = g;
var F = "AccordionHeader", G = l.forwardRef(
  (o, n) => {
    const { __scopeAccordion: e, ...r } = o, c = b(d, e), a = D(F, e);
    return /* @__PURE__ */ t.jsx(
      V.h3,
      {
        "data-orientation": c.orientation,
        "data-state": B(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        ...r,
        ref: n
      }
    );
  }
);
G.displayName = F;
var P = "AccordionTrigger", U = l.forwardRef(
  (o, n) => {
    const { __scopeAccordion: e, ...r } = o, c = b(d, e), a = D(P, e), s = fe(P, e), i = k(e);
    return /* @__PURE__ */ t.jsx(S.ItemSlot, { scope: e, children: /* @__PURE__ */ t.jsx(
      ne,
      {
        "aria-disabled": a.open && !s.collapsible || void 0,
        "data-orientation": c.orientation,
        id: a.triggerId,
        ...i,
        ...r,
        ref: n
      }
    ) });
  }
);
U.displayName = P;
var Y = "AccordionContent", q = l.forwardRef(
  (o, n) => {
    const { __scopeAccordion: e, ...r } = o, c = b(d, e), a = D(Y, e), s = k(e);
    return /* @__PURE__ */ t.jsx(
      re,
      {
        role: "region",
        "aria-labelledby": a.triggerId,
        "data-orientation": c.orientation,
        ...s,
        ...r,
        ref: n,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...o.style
        }
      }
    );
  }
);
q.displayName = Y;
function B(o) {
  return o ? "open" : "closed";
}
var Ae = M, ge = z, Ce = G, J = U, Q = q;
const He = Ae, be = /* @__PURE__ */ t.jsx(se, { className: "tw-shrink-0 tw-transition-transform tw-duration-200" }), he = E.forwardRef(({
  className: o,
  showDivider: n = !0,
  ...e
}, r) => /* @__PURE__ */ t.jsx(ge, { ref: r, className: v({
  "tw-border-b tw-border-b-gray-300": n
}, o), ...e }));
he.displayName = "AccordionItem";
const Ie = E.forwardRef(({
  triggerIcon: o = be,
  className: n,
  children: e,
  ...r
}, c) => /* @__PURE__ */ t.jsx(Ce, { className: "tw-flex tw-text-gray-900 tw-m-0", children: /* @__PURE__ */ t.jsxs(J, { ref: c, className: v("tw-flex tw-flex-1 tw-items-center tw-justify-between tw-py-16 tw-font-medium tw-transition-all hover:tw-underline [&[data-state=open]>svg]:tw-rotate-180", n), ...r, children: [
  e,
  o
] }) }));
Ie.displayName = J.displayName;
const je = E.forwardRef(({
  className: o,
  children: n,
  forceMount: e,
  ...r
}, c) => /* @__PURE__ */ t.jsx(Q, { ref: c, forceMount: e, className: v("tw-overflow-hidden tw-body-2 tw-text-gray-900", {
  // these are only applied when forceMount is false
  "tw-transition-all data-[state=closed]:tw-animate-accordion-up data-[state=open]:tw-animate-accordion-down": !e
}), ...r, children: e ? (
  // When forceMount is true, we use a grid-row transition instead of the usual height animation.
  // (radix does not update the --radix-accordion-content-height variable when forceMount is true)
  /* @__PURE__ */ t.jsx("div", { className: "tw-grid tw-overflow-hidden tw-transition-[grid-template-rows] tw-duration-200 tw-ease-out [grid-template-rows:1fr] [[data-state=closed]_&]:[grid-template-rows:0fr]", children: /* @__PURE__ */ t.jsx("div", { className: "tw-overflow-hidden tw-min-h-0", children: /* @__PURE__ */ t.jsx("div", { className: v("tw-pb-16", o), children: n }) }) })
) : /* @__PURE__ */ t.jsx("div", { className: v("tw-pb-16", o), children: n }) }));
je.displayName = Q.displayName;
export {
  He as A,
  je as a,
  he as b,
  Ie as c
};
//# sourceMappingURL=Accordion.nAcmdOfN.js.map
